import React from 'react';

import { bemCssModules } from '@utils';

import { notificationsActions, useStore } from '@modules';
import { NotificationTypesEnum } from '@modules/notifications/types';

import Notification from './Notification';
import Toast from './Toast';

import styles from './Notifications.scss';

const cn = bemCssModules(styles, 'Notifications');
const { error, toast } = NotificationTypesEnum;

const emailRegExp = /([a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4})/gi;

const linkifyText = (textToLinkify: string, regExp: RegExp): (React.JSX.Element | string)[] => {
  return textToLinkify.split(regExp).map((substr, idx) => {
    const href = `mailto:${substr}`;
    if (idx % 2 !== 1) return substr;
    return (
      <a className="link" href={href} key={href}>
        {substr}
      </a>
    );
  });
};

const Notifications: CustomFC = props => {
  const { className } = props;

  const [{ notifications }, dispatch] = useStore();
  const { list } = notifications;

  return (
    <div className={cn(null, [className])}>
      {list.map(item => {
        const { type, message, title, code, id } = item;
        const onClose = () => dispatch(notificationsActions.remove(id));
        const commonProps = {
          key: id,
          className: cn('notification'),
          title,
          code,
          message: linkifyText(message, emailRegExp),
          onClose,
        };
        switch (type) {
          case toast:
            return <Toast key={id} className={cn('toast')} message={message} onClose={onClose} />;
          case error:
            return <Notification {...commonProps} error />;
          default:
            return <Notification {...commonProps} />;
        }
      })}
    </div>
  );
};

export default Notifications;
